type CardProps = {
  children: JSX.Element | JSX.Element[];
};

export function Card({ children }: CardProps) {
  return <div className="rounded-3xl bg-white  p-8 shadow-vidalink">{children}</div>;
}
